import React from 'react';

import { GamesInfoPopup as GamesInfoPopupBare } from 'js/app/components/popups/GamesInfoPopup/GamesInfoPopup';

export const GamesInfoPopup = (props) => <GamesInfoPopupBare {...props} isLogoHidden />;
